module.exports = __webpack_public_path__ + "img/roman-Unselected.3317effd.webp";